import React from 'react';
import GenericTable from '../../../shared/GenericTable';
import { MRT_ColumnDef } from 'mantine-react-table';

const AIHistoryAvailabilityTable = ({ data }: { data: any }) => {
    const columns: MRT_ColumnDef<any>[] = [
        {
            accessorKey: 'startDate',
            header: 'Start Date',
            size: 100,
            Cell: ({ cell, row }) => (
                <span
                    style={{
                        color:
                            row.original?.isAvailable === false
                                ? 'red'
                                : 'inherit',
                    }}
                >
                    {cell.getValue<string>()}
                </span>
            ),
        },
        {
            accessorKey: 'endDate',
            header: 'End Date',
            size: 100,
            Cell: ({ cell, row }) => (
                <span
                    style={{
                        color:
                            row.original?.isAvailable === false
                                ? 'red'
                                : 'inherit',
                    }}
                >
                    {cell.getValue<string>()}
                </span>
            ),
        },
        {
            accessorKey: 'isAvailable',
            header: 'Availability',
            size: 100,
            Cell: ({ cell, row }) => {
                const value = cell.getValue();
                return (
                    <span style={{ color: value ? 'inherit' : 'red' }}>
                        {value ? 'Available' : 'Unavailable'}
                    </span>
                );
            },
        },
        {
            accessorKey: 'reason',
            header: 'Reason',
            size: 200,
            Cell: ({ cell, row }) => (
                <div
                    style={{
                        whiteSpace: 'normal',
                        wordBreak: 'break-word',
                        color:
                            row.original?.isAvailable === false
                                ? 'red'
                                : 'inherit',
                    }}
                >
                    {cell.getValue<string>()}
                </div>
            ),
        },
    ];

    return (
        <GenericTable
            columns={columns}
            data={data}
            tableName='Availability'
            loading={!data}
            enableBottomToolbar={false}
            enableTopToolbar={false}
            maxHeight={'370px'}
            enableSorting={false}
            enableColumnActions={false}
            enableRowSelection={false}
        />
    );
};

export default AIHistoryAvailabilityTable;
